import React from 'react'
import { Dropdown, Space } from 'antd'
import styles from './CardMenu.module.css'

type Props = {
    label: React.ReactNode;
    items: any;
    open: any;
    setOpenDropdown: any;
    onOpenChange:any
}

const CardMenu = (props: Props) => {
    
  const { label, items, open, setOpenDropdown, onOpenChange } = props;

  return (
    <Dropdown onOpenChange={onOpenChange} arrow open={open} menu={{ items }} trigger={['click']}>
    <a onClick={(e) => e.preventDefault()}>
      <Space onClick={()=> setOpenDropdown(true)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className= {`bi bi-three-dots-vertical ${styles.cardMenuIcon}`} viewBox="0 0 16 16">
  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
</svg>
      </Space>
    </a>
  </Dropdown>
  )
}

export default CardMenu

